/* Order forms: English (base). Texts are identical to the Tally forms eqgMDo and 68gxGJ,
   plus the exchange path (exchange_*), which the Tally form does not have.
   Choice options use their English value as the label, so they need no entry here. */
window.OrderFormsI18n = window.OrderFormsI18n || {};
window.OrderFormsI18n.en = {
  ui: {
    next: 'Next',
    back: 'Back',
    submit: 'Submit',
    sending: 'Sending…',
    required: 'Please fill in this field.',
    email: 'Please enter a valid email address.',
    files_choose: 'Click to choose a file or drag it here',
    files_hint: 'Up to 10 images, 5 MB each',
    too_many: 'You can upload up to 10 files here.',
    too_big: 'Each file must be 5 MB or smaller.',
    file_type: 'Please upload an image or a PDF.',
    remove: 'Remove',
    error: 'Something went wrong and your request was not sent. Please try again in a moment.'
  },
  resolution: {
    title: 'Order Resolution Center',
    fields: {
      help_with: 'What do you need help with?',
      order_number: 'Order number',
      email: 'Email used at checkout',
      full_name: 'Full name on the order',
      postcode: 'Shipping postcode or ZIP code',
      card_last4: 'Last 4 digits of the card used',
      issue_type: "What's the issue with your order?",
      tracking_status: 'What does your tracking currently say?',
      checked_places: 'Before we continue, please confirm you have checked all of these',
      delivery_address: 'Full delivery address exactly as you entered it',
      damage_photos: 'Photos of the damage',
      packaging_photo: 'Photo of the outer packaging with the shipping label visible',
      item_usable: 'Is the item still usable?',
      damage_description: 'Describe the damage in your own words',
      item_received_photo: 'Photo of the item you received',
      shipping_label_photo: 'Photo of the shipping label',
      wrong_what: "What's wrong with it?",
      order_vs_received: 'What did you order, and what arrived?',
      date_received: 'Date you received the item',
      item_condition: 'Has the item been opened or used?',
      return_reason: 'Why are you returning it?',
      return_photo: 'Photo of the item in its current condition',
      exchange_reason: 'Why would you like to exchange it?',
      exchange_details: 'Which item are you exchanging, and what would you like instead? Please include the size, colour or product name.',
      exchange_date_received: 'Date you received the item',
      exchange_condition: 'Has the item been opened or used?',
      exchange_photo: 'Photo of the item in its current condition (if it is defective, show the defect)',
      exchange_packaging_photo: 'Photo of the original packaging',
      exchange_confirmations: 'Please confirm before submitting',
      charge_date: 'Date of the charge',
      charge_amount: 'Charge amount and currency',
      statement_descriptor: 'Exactly how does the charge appear on your statement?',
      household_use: 'Could anyone else in your household have used this card?',
      statement_screenshot: 'Screenshot of the charge on your statement',
      requested_resolution: 'How would you like us to resolve this?',
      bank_contacted: 'Have you already contacted your bank or card issuer about this charge?',
      confirmations: 'Please confirm before submitting'
    },
    placeholders: {
      exchange_details: "Example: I received [product name] in [size, colour or model] and I'd like to exchange it for [product name] in [size, colour or model]."
    },
    contact: '{store} — need to reach us directly? Email {email} with your order number.',
    thanks: [
      "Thank you. We've received your information.",
      'Our team will review your case and contact you by email within 24 hours.',
      "Please check your spam folder if you don't see our reply. Replying to that email is the fastest way to reach the person handling your case."
    ]
  },
  eu: {
    title: 'Withdraw from contract',
    fields: {
      full_name: 'Full name',
      email: 'Email address used on the order',
      order_number: 'Order number',
      purchase_date: 'Date of purchase',
      received_date: 'Date you received the order',
      withdraw_scope: 'What would you like to withdraw from',
      items: 'If only some items, list them here',
      reason: 'Reason (optional)'
    },
    options: {
      withdraw_scope: { whole: 'The whole order', some: 'Only some items' }
    },
    thanks: [
      'Your withdrawal request has been recorded.',
      'We will email you a confirmation of receipt. Your 14 days and your refund are counted from the moment you submitted this form.'
    ]
  }
};
